import {AppUrls} from 'shared/config/model/urls';

import React, {useEffect, useState, useMemo} from 'react';
import {useMutex} from 'react-context-mutex';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {unwrapResult} from '@reduxjs/toolkit';
import {useParams} from 'react-router';
import {t} from '@lingui/core/macro';

import Button from 'shared/ui/Button/Button/Button';
import {IUserOutput, confirmChangeEmail} from 'entities/user';
import {TypedDispatch} from 'shared/model/types';
import {useIsMount} from 'shared/lib/hooks/useIsMount';

import AuthWrapper from './AuthWrapper';

import styles from './Auth.module.scss';

interface IProfileProps {
    user: IUserOutput,
}

const ConfirmChangeEmail: React.FC<IProfileProps> =  ({user}) => {
    const [message, setMessage] = useState<string>();
    const [status, setStatus] = useState<boolean | null>(null);
    
    const dispatch = useDispatch<TypedDispatch>();
    const MutexRunner = useMutex();
    const navigate = useNavigate();

    const handleContinue = () => {
        navigate(AppUrls.SETTINGS);
    };

    const mutex = useMemo(() => new MutexRunner('changeEmailConfirm'), [MutexRunner]);

    const isMount = useIsMount();
    const {userId, token} = useParams();

    useEffect(() => {
        if(!token || !userId ||!user || !isMount) {
            return;
        }

        if(Number(userId) !== user.id) {
            setMessage(t`Некорректная ссылка`);
            setStatus(false);
            return;
        }

        mutex.run(async() => {
            mutex.lock();
            try {
                const resultAction = await dispatch(confirmChangeEmail({userId: Number(userId), token}));
                const response = unwrapResult(resultAction);
                setMessage(response.message);
                setStatus(response.status);
            } catch (error: any) {
                setMessage(error.message);
                setStatus(false);
            }finally {
                mutex.unlock();
            }
        });

    }, [userId, token, user, dispatch, isMount, mutex]);

    return (
        <AuthWrapper>
            <div className={styles.box_wrapper_confirm}>
                <div className="row text-center mb-3">
                    <div className="col-12">
                        <h2 className={styles.title}>
                            {t`Подтверждение изменения E-mail`}
                        </h2>
                        {
                            message && <p>{message}</p>
                        }
                    </div>
                </div>

                {
                    status &&
                        <Button
                            onClick={handleContinue}
                            block
                        >
                            {t`Продолжить`}
                        </Button>
                }
            </div>
        </AuthWrapper>
    );
};

export default ConfirmChangeEmail;